module.exports = __webpack_public_path__ + "static/media/biglogo.9a85386d.png";